// Постоянното съобщение над таблицата на „Продадени продукти" и „Продадени
// рецепти": справките броят САМО сметките от разнесени отчети (BE
// `_posted_report_bill_ids`), затова днешните продажби липсват, докато отчетът
// на заведението не е направен и разнесен. Ако има чакащи отчети (броят от
// `/inventory/nav-counts`, общият кеш със значката в менюто) — „Чакат
// разнасяне: N отчета" и бутон „Разнеси" към операцията. Тон — информация
// (синьо), не предупреждение. В локален режим мълчи.
import { InfoCircleOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { useIsEdgeLocal } from "../../../../hooks/useEdgeMode";
import { useInventoryNavCounts } from "../../../../hooks/useInventoryNavCounts";
import { SECONDARY_BUTTON_CLASS } from "../../components/list/buttonStyles";
import { useInventoryShell } from "../../components/shell/InventoryShellContext";

const POSTING_PATH = "/inventory/posting";

export const SoldPostedOnlyNotice = () => {
  const { t } = useTranslation();
  const isLocal = useIsEdgeLocal();
  const { navigateGuarded } = useInventoryShell();
  const navCounts = useInventoryNavCounts();
  if (isLocal) return null;
  const pendingReports = navCounts.data?.pendingReports ?? 0;

  return (
    <div
      role="note"
      className="flex flex-wrap items-center gap-x-3.5 gap-y-2 rounded-xl border border-info/30 bg-info-tint px-4 py-2.5"
    >
      <span className="flex min-w-[220px] flex-1 items-start gap-2 text-[13px] leading-[1.45] text-info-deep">
        <InfoCircleOutlined aria-hidden className="mt-[3px] shrink-0" />
        <span>{t("inventoryPage.soldPostedOnlyNotice")}</span>
      </span>
      {pendingReports > 0 && (
        <span className="flex flex-wrap items-center gap-2.5">
          <span className="whitespace-nowrap text-[13px] font-semibold text-info-deep">
            {t("inventoryPage.soldPendingReports", { count: pendingReports })}
          </span>
          <button
            type="button"
            onClick={() => navigateGuarded(POSTING_PATH)}
            className={`${SECONDARY_BUTTON_CLASS} !py-1.5`}
          >
            {t("inventoryPage.soldPostAction")}
          </button>
        </span>
      )}
    </div>
  );
};

export default SoldPostedOnlyNotice;
